import {useCallback, useEffect, useRef} from 'react'

const LEGACY_OPEN_DIALOG_SELECTOR = '[role="dialog"][data-state="open"]'

// TEMPORARY: the legacy s-ui modals (e.g. the share modal) are Radix dialogs, while this gallery uses the
// base-ui Dialog from @adv-mt/ui. Each library only knows its own layer stack, so one Escape closes both.
// Radix closes its modal first and React removes it before our handler runs, so the DOM is read in the
// capture phase, at the start of the keypress. Delete this hook once those modals move to the new Dialog.
const useLegacyModalEscapeGuard = ({isOpen, onClose}) => {
  const hadLegacyDialogOnEscapeRef = useRef(false)

  useEffect(() => {
    if (!isOpen) return
    const handleEscapeCapture = e => {
      if (e.key === 'Escape') {
        hadLegacyDialogOnEscapeRef.current = Boolean(document.querySelector(LEGACY_OPEN_DIALOG_SELECTOR))
      }
    }
    window.addEventListener('keydown', handleEscapeCapture, true)
    return () => window.removeEventListener('keydown', handleEscapeCapture, true)
  }, [isOpen])

  return useCallback(
    (open, eventDetails) => {
      if (open) return
      if (eventDetails?.reason === 'escape-key' && hadLegacyDialogOnEscapeRef.current) {
        eventDetails.cancel()
        return
      }
      onClose()
    },
    [onClose]
  )
}

export default useLegacyModalEscapeGuard
